import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {AuthService} from '../service/auth.service';

@Injectable()
export class CanActivateAuthGuard  {
    private router = inject(Router);
    private authService = inject(AuthService);


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        if (this.authService.isLoggedIn() && this.authService.getUser() != null) {
            let userRoles = this.authService.getUser().getUserRoles();
            let roles = route.data["roles"] as Array<string>;
            if (roles != null && userRoles != null && this.findOne(roles, userRoles)) {
                return true;
            }
        }
        this.router.navigate(['/login'], {queryParams: {returnUrl: state.url}});
        return false;
    }

    findOne(haystack, arr) {
        return arr.some(function (v) {
            return haystack.indexOf(v) >= 0;
        });
    };
}
